import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'

export function Checkbox({ className = '', ...props }) {
  return <CheckboxPrimitive.Root className={`shadcn-checkbox ${className}`.trim()} {...props}>
    <CheckboxPrimitive.Indicator className="shadcn-checkbox-indicator">
      <Check aria-hidden="true"/>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
}
